<div class="snooker-scoreboard-header">
    <div class="cell points" *ngIf="points">{{ scoreboardP }}</div>
    <div class="cell frames" *ngIf="frames">{{ scoreboardF }}</div>
</div>
